import React, { useState, useEffect } from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";
import { TextFormType, TextInputType } from "@utils/types/components";
import TextInput from "./TextInput";
import { FormInputController } from "./FormInputController";

export interface FormTextInputProps<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    TextInputType {
  fieldMeta: TextFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
  onBlur?: () => void;
}

const FormTextInput = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  readOnly,
  onBlur,
  ...props
}: FormTextInputProps<TFormFields>) => {
  const [isReadOnly, setIsReadOnly] = useState(readOnly);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsReadOnly(false);
    }, 650);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({
        onBlur: onControllerBlur,
        onChange: onControllerChange,
        ...controllerProps
      }) => (
        <TextInput
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          readOnly={isReadOnly}
          onChange={(...event) => {
            onControllerChange(...event);

            fieldMeta.onChange && fieldMeta.onChange(...event);
          }}
          onBlur={() => {
            onControllerBlur();

            onBlur && onBlur();
          }}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};

export default FormTextInput;
